function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.0301 2.96997C22.4276 4.36743 22.4276 6.63317 21.0301 8.03063L9.06186 19.999C8.78498 20.2758 8.44064 20.4757 8.06288 20.5787L2.94719 21.9739C2.38732 22.1266 1.87359 21.6128 2.02628 21.053L3.42147 15.9373C3.5245 15.5595 3.72432 15.2152 4.0012 14.9383L15.9695 2.96997C17.3669 1.57251 19.6327 1.57251 21.0301 2.96997ZM15 6.06088L5.06186 15.999C4.96957 16.0913 4.90296 16.206 4.86862 16.332L3.81877 20.1814L7.66821 19.1315C7.79413 19.0972 7.90891 19.0306 8.0012 18.9383L17.939 8.99988L15 6.06088ZM17.0301 4.03063L16.06 4.99988L18.999 7.93988L19.9695 6.96997C20.7811 6.1583 20.7811 4.84231 19.9695 4.03063C19.1578 3.21896 17.8418 3.21896 17.0301 4.03063Z"
}));

var SvgEditIcon = function SvgEditIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    opacity: 0.7,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit_icon.19d7fc0e.svg";
export { ForwardRef as ReactComponent };